import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { asyncComponent } from './components/AsyncComponent';
import { AppliedRoute } from './components/AppliedRoute';
//import AuthenticatedRoute from './components/AuthenticatedRoute';
//import UnauthenticatedRoute from './components/UnauthenticatedRoute';

const AsyncWebPage = asyncComponent(() => import('./WebPage'));
const AsyncViewer = asyncComponent(() => import('./viewer/main'));

export default ({ childProps }: any) => (
  <Switch>
    <AppliedRoute path="/view/:id" component={AsyncViewer} props={childProps} />
    {/*         <UnauthenticatedRoute path="/login" exact component={AsyncLogin} props={childProps} />
                    <UnauthenticatedRoute path="/signup" exact component={AsyncSignup} props={childProps} />
                    <AuthenticatedRoute path="/notes/new" exact component={AsyncNewNote} props={childProps} />
                    <AuthenticatedRoute path="/notes/:id" exact component={AsyncNotes} props={childProps} />
             */}
    {/* Finally, catch all unmatched routes */}
    <AppliedRoute component={AsyncWebPage} props={childProps} />;
  </Switch>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Routes.tsx